import { Calc, MidpointRounding } from '@skylab-shared/utils';
import { VatTableItem, VatTableItemRecalculation, VatTableItemRecalculationChanges, VatTableItemRecalculationChangesProperty } from './vat-table-item-recalculation';

export class VatTableItemGrossRecalculation extends VatTableItemRecalculation {
    public recalculate(item: VatTableItem, precision: number, triggeredBy?: VatTableItemRecalculationChangesProperty): Readonly<Required<VatTableItem>> {
        const result = { ...item };
        const tBy = triggeredBy as VatTableItemRecalculationChangesProperty;

        if (VatTableItemRecalculationChanges.netChanged(tBy)) {
            this.recalculateFromNet(result, precision);
        } else {
            this.recalculateFromGross(result, precision);
        }

        return <Required<VatTableItem>> result;
    }

    private recalculateFromNet(item: VatTableItem, precision: number): void {
        item.grossValue = Calc.round(item.netValue! * (1 + item.vatRate!), precision, MidpointRounding.AwayFromZero);
        this.recalculateFromGross(item, precision);
    }

    private recalculateFromGross(item: VatTableItem, precision: number): void {
        item.vatValue = Calc.round(item.grossValue! * item.vatRate! / (1 + item.vatRate!), precision, MidpointRounding.AwayFromZero);
        item.netValue = Calc.round(item.grossValue! - item.vatValue, precision, MidpointRounding.AwayFromZero);
    }
}
